import { render, staticRenderFns } from "./FAQS.vue?vue&type=template&id=65fe62e9&"
import script from "./FAQS.vue?vue&type=script&lang=js&"
export * from "./FAQS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports